var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrafficmanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.92,22.32c2.31,0,6.19-0.6,7.89-2.59c0.04-0.06,0.4-0.51,0.24-0.96c-0.56-1.66-1.57-4.44-1.95-5.5 c-0.28,0.1-2.89,1.54-6.09,1.54c-3.43,0-5.61-1.35-6.12-1.53c-0.03,0.09-1.68,4.72-1.93,5.45c-0.1,0.32-0.01,0.81,0.31,1.05 C19.09,20.41,20.91,22.32,25.92,22.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.36,28.2l-0.59,0.5c-4.92,4.2-16.47,4.18-21.58-0.01l-0.62-0.51l-0.71,2.02c-1.08,3.05-1.46,3.37-0.86,4.51 c0.54,1.05,1.45,1.67,2.18,2.08c9.11,5.17,26.07,1.27,23.89-4.05C38.18,30.59,38.61,31.16,37.36,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.67,27c-1.08-0.53-0.43,0.42-7.82-20.22c-1.75-4.92-8.02-4.76-9.7,0c-1.49,4.18-5.16,14.44-6.79,19.05 c-0.39,1.09-0.51,0.89-6.54,3.91c-3.93,2.12-5.41,2.29-6.29,3.91c-0.54,0.97-0.67,2.07-0.36,3.07c0.33,1.06,1.11,1.95,2.21,2.5 c17.17,8.63,18.34,9.65,22.92,9.65c3.92,0,5.82-1.37,17.67-7.32c4.18-2.26,5.56-2.32,6.51-4.02c0.53-0.98,0.66-2.07,0.35-3.07 C50.14,32.23,48.87,32.05,38.67,27z M17.97,18.73c0.25-0.74,1.9-5.36,1.93-5.45c0.5,0.18,2.69,1.53,6.12,1.53 c3.2,0,5.81-1.43,6.09-1.54c0.38,1.06,1.38,3.84,1.95,5.5c0.16,0.46-0.21,0.91-0.24,0.96c-1.69,1.99-5.57,2.59-7.89,2.59 c-5.01,0-6.83-1.92-7.64-2.54C17.96,19.55,17.86,19.05,17.97,18.73z M15.18,36.8c-0.73-0.41-1.64-1.03-2.18-2.08 c-0.6-1.14-0.22-1.46,0.86-4.51l0.71-2.02l0.62,0.51c5.11,4.19,16.66,4.21,21.58,0.01l0.59-0.5c1.25,2.96,0.81,2.38,1.71,4.55 C41.25,38.07,24.29,41.97,15.18,36.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficmanagement);
export default __webpack_public_path__ + "static/media/trafficmanagement.53b8084dfa5cb07bd7f54dceeaea3b5d.svg";
export { ForwardRef as ReactComponent };